export const getQueryParam = (key: string): string | null => {
    if (typeof window === 'undefined') return null;

    if (typeof URLSearchParams === 'undefined') {
        const results = new RegExp('[?&]' + key + '=([^&#]*)').exec(window.location.href);
        return results === null ? null : decodeURI(results[1]) ?? null;
    }
    
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(key);
};